import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "25",
  height: "25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M6.11 17.717H5.5a.5.5 0 0 1-.5-.5V5.024a1 1 0 0 1 .293-.707l1.024-1.024A1 1 0 0 1 7.024 3h10.67a1 1 0 0 1 .706.293l1.024 1.024a1 1 0 0 1 .293.707v12.193a.5.5 0 0 1-.5.5h-.61a.5.5 0 0 1-.5-.5V6.11a1.5 1.5 0 0 0-1.5-1.5H8.11a1.5 1.5 0 0 0-1.5 1.5v11.107a.5.5 0 0 1-.5.5Z",
  fill: "#525052",
  "fill-opacity": ".45",
  stroke: "#D5D4D6",
  "stroke-width": ".75"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "m9.293 11.585 1.38-1.062v2.124l-1.38-1.062ZM15.425 11.585l-1.38 1.062v-2.124l1.38 1.062Z",
  fill: "#D5D4D6"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12.359 4.84v12.877M5.613 17.717h13.49",
  stroke: "#D5D4D6",
  "stroke-width": ".75"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}
export default { render: render }